import React from "react";
import Header from "../components/Header";
import CoursesSection from "../components/agents/AgentsSection";
import HeroAgentsSection from "../components/agents/HeroAgentsSection";
import AgentsSection from "../components/agents/AgentsSection";
import AgentToolsSection from "../components/agents/AgentToolsSection";
import AgentsFeaturesSection from "../components/agents/AgentsFeaturesSection";
import AgentsTestimonialsSection from "../components/agents/AgentsTestimonialsSection";
import AgentsFinalCTASection from "../components/agents/AgentsFinalCTASection";
import Footer from "../components/Footer";

import "../styles/homepage.css";

const AgentsHome = () => {
  return (
    <>
      <Header />
      <main>
        <HeroAgentsSection />
        <AgentsSection />
        <AgentToolsSection />
        <AgentsFeaturesSection />
        <AgentsTestimonialsSection />
        <AgentsFinalCTASection />
      </main>
      <Footer />
    </>
  );
};

export default AgentsHome;
